<template>
  <div class="iframe_div">
    <iframe ref="iframeRef" :src="url" frameborder="0" class="iframe"></iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {
      params: {},
      url: `/neuron-cloud-login-ui/#/?theme=light&language=en`,
    };
  },
  mounted() {
    window.addEventListener("message", this.handleMessage);
    this.$refs.iframeRef.addEventListener("load", () => {
      this.$refs.iframeRef.contentWindow.postMessage({
        cmd: "INIT_APP",
        // data: {},
      });
    });
  },
  methods: {
    init() {
      const { query } = this.$route;
      const paths = this.$store.getters.getAwsConfigItem({
        key: "pathList",
        subKey: "paths",
      });
      console.log("paths", paths, query);
      // this.url = paths.login;

      if (JSON.stringify(query) === "{}") {
        const { path } = this.$router.history.current;
        this.$router.push({
          path,
          query: {
            theme: "default",
            language: "en",
          },
        });
      }
    },
    handleOnCallback(result) {
      if (result.isSuccess) {
        const userInfo = result.data || {};
        const { refreshToken, expiresIn, username, token, expirationTime } =
          result;
        this.$store.dispatch("app/updateParams", { expiresIn });
        this.$store.dispatch("app/updateParams", { token });
        this.$store.dispatch("app/updateParams", { refreshToken });
        this.$store.dispatch("app/updateParams", {
          userInfo: JSON.stringify(userInfo),
        });
        this.$store.dispatch("app/updateParams", { username });
        this.$store.dispatch("app/updateParams", { expirationTime });
        console.warn(this.$store.state);
        window.removeEventListener("message", this.handleMessage, true);
        this.$router.push({
          path: "/Application",
          query: this.$route.query,
        });
      }
    },

    async handleMessage(event) {
      // console.log(event);
      if (event && event.type === "message") {
        if (event?.data?.cmd === "send_token") {
          const result = event.data.data;
          if (result.isSuccess) {
            const userInfo = result.data || {};
            const { refreshToken, expiresIn, username, token, expirationTime } =
              result;
            this.$store.dispatch("app/updateParams", { expiresIn });
            this.$store.dispatch("app/updateParams", { token });
            this.$store.dispatch("app/updateParams", { refreshToken });
            this.$store.dispatch("app/updateParams", {
              userInfo: JSON.stringify(userInfo),
            });
            this.$store.dispatch("app/updateParams", { username });
            this.$store.dispatch("app/updateParams", { expirationTime });
            console.warn(this.$store.state);
            window.removeEventListener("message", this.handleMessage, true);
            this.$router.push({
              path: "/Application",
              query: this.$route.query,
            });
          }
        }
      }
    },
  },
  created() {
    this.init();
  },
};
</script>
